export default __webpack_public_path__ + "static/media/new-years-banner.c71e8bb5.png";